// BiovicaLogo.tsx
import React from "react";
import type { SVGProps } from "react";
import BiovicaLogoPng from "../../assets/biovica-logo.png";

type Props = (JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) & {
  /** If true, emit an <img> with the PNG asset (best for html2canvas/pdf). */
  asImgForPdf?: boolean;
  imgWidth?: number;   // px
  imgHeight?: number;  // px
  className?: string;
  width?: string | number;  // e.g. "100%" or 200
  height?: string | number; // e.g. "100%" or 50
};

export default function BiovicaLogo({
  asImgForPdf,
  imgWidth = 90,
  imgHeight = 30,
  className,
  width,
  height,
  ...props
}: Props) {
  if (asImgForPdf) {
    return (
      <img
        src={BiovicaLogoPng}
        alt="Biovica"
        width={imgWidth}
        height={imgHeight}
        style={{ display: "block" }}
      />
    );
  }

  // Important: give explicit numeric width/height; avoid % for html2canvas
  return (
    <svg
      id="footer_logo_svg"
      className={className || ""}
      width={width || "100%"}
      data-name="Lager 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 466.79 81.15"
      {...props}
    >
      <path className="cls-1" style={{ fill: '#1d1d1b' }} d="m24.71,76.61H0V3.66h19.15c6.03,0,10.74.81,14.13,2.43,3.38,1.62,5.96,3.85,7.74,6.69,1.78,2.84,2.67,6.12,2.67,9.84,0,7.17-3.74,12.31-11.2,15.41,5.33,1.01,9.57,3.2,12.72,6.58,3.15,3.38,4.73,7.41,4.73,12.11,0,3.72-.96,7.05-2.87,9.97-1.91,2.93-4.73,5.31-8.44,7.15-3.71,1.85-8.35,2.77-13.92,2.77Zm-5.16-63.59h-9.02v21.85h6.97c5.59,0,9.56-1.06,11.92-3.17,2.36-2.12,3.54-4.86,3.54-8.22,0-6.97-4.47-10.45-13.42-10.45Zm.75,31.21h-9.77v23.02h10.29c5.71,0,9.58-.44,11.62-1.32,2.04-.88,3.67-2.26,4.91-4.13,1.24-1.87,1.86-3.88,1.86-6.03s-.66-4.25-1.96-6.08c-1.3-1.83-3.16-3.2-5.56-4.11-2.4-.9-6.2-1.35-11.38-1.35Z"></path>
      <path className="cls-1" style={{ fill: '#1d1d1b' }} d="m76.39,3.66h10.53v72.95h-10.53V3.66Z"></path>
      <path className="cls-2" style={{ fill: '#73a2cd' }} d="m152.99,0c12.17,0,22.3,3.87,30.39,11.61,8.09,7.74,12.14,17.44,12.14,29.1s-4.08,21.32-12.25,28.97c-8.17,7.64-18.46,11.47-30.89,11.47s-21.75-3.82-29.66-11.47c-7.91-7.64-11.86-17.22-11.86-28.74s3.98-21.59,11.94-29.33c7.96-7.74,18.02-11.61,30.19-11.61Zm.42,10.73c-8.99,0-16.38,2.84-22.17,8.51-5.79,5.68-8.68,12.92-8.68,21.73s2.9,15.66,8.71,21.33c5.81,5.68,13.08,8.51,21.8,8.51s16.08-2.89,21.94-8.68c5.86-5.78,8.8-12.99,8.8-21.62s-2.93-15.46-8.8-21.19c-5.86-5.73-13.06-8.59-21.6-8.59Z"></path>
      <path className="cls-1" style={{ fill: '#1d1d1b' }} d="m256.56,3.66h10.43l-30.94,73.34h-2.49L202.42,3.66h10.5l21.79,51.32,21.86-51.32Z"></path>
      <path className="cls-1" style={{ fill: '#1d1d1b' }} d="m287.98,3.66h10.53v72.95h-10.53V3.66Z"></path>
      <path className="cls-1" style={{ fill: '#1d1d1b' }} d="m385.52,59.83v11.51c-7.67,4.16-16.51,6.24-26.54,6.24-8.15,0-15.07-1.64-20.75-4.92-5.68-3.28-10.17-7.8-13.48-13.56-3.31-5.76-4.96-11.99-4.96-18.69,0-10.64,3.79-19.59,11.37-26.85,7.58-7.26,16.92-10.89,28.04-10.89,7.66,0,16.18,1.95,25.55,5.85v11.31c-8.55-4.81-16.91-7.22-25.07-7.22s-15.33,2.65-20.86,7.94c-5.53,5.29-8.3,11.92-8.3,19.89s2.72,14.64,8.17,19.81c5.44,5.17,12.4,7.76,20.88,7.76s17.51-2.73,25.96-8.19Z"></path>
      <path className="cls-1" style={{ fill: '#1d1d1b' }} d="m426.56,3.27h7.49l32.67,73.34h-10.68l-9.69-21.46h-31.09l-9.02,21.46h-10.73L426.56,3.27Zm15.62,42.52l-11.85-26.5-10.93,26.5h22.77Z"></path>
      <polygon className="cls-1" style={{ fill: '#1d1d1b' }} points="171.66 35.6 157.95 35.6 157.95 21.9 148.59 21.9 148.59 35.6 134.88 35.6 134.88 44.97 148.59 44.97 148.59 58.68 157.95 58.68 157.95 44.97 171.66 44.97 171.66 35.6"></polygon>
      <path className="cls-1" style={{ fill: '#1d1d1b' }} d="m458.67,3.09c1.45,0,2.8.36,4.05,1.09,1.25.73,2.25,1.72,2.97,2.97.73,1.25,1.09,2.6,1.09,4.05s-.36,2.81-1.09,4.05c-.72,1.25-1.71,2.23-2.97,2.96-1.25.72-2.61,1.09-4.06,1.09s-2.82-.36-4.08-1.08c-1.25-.72-2.24-1.71-2.97-2.96-.72-1.25-1.09-2.6-1.09-4.06s.36-2.81,1.09-4.06c.73-1.25,1.72-2.24,2.97-2.96,1.25-.72,2.61-1.09,4.06-1.09Zm0,1.34c-1.86,0-3.46.66-4.78,1.98s-1.98,2.92-1.98,4.78.66,3.46,1.98,4.78,2.91,1.97,4.78,1.97,3.45-.66,4.77-1.98c1.32-1.32,1.98-2.91,1.98-4.77s-.66-3.46-1.98-4.78-2.91-1.98-4.77-1.98Zm-1.84,11.12h-1.41V6.83h3.02c1.07,0,1.82.08,2.26.25.44.17.79.45,1.06.84.27.39.4.81.4,1.26,0,.67-.23,1.23-.7,1.69-.47.46-1.06.72-1.8.77.33.14.64.36.93.67.29.31.66.82,1.1,1.53l1.05,1.7h-1.72l-.76-1.37c-.55-.98-.99-1.62-1.31-1.91-.32-.29-.75-.43-1.29-.43h-.84v3.71Zm0-7.54v2.62h1.72c.73,0,1.26-.11,1.6-.32.34-.21.51-.55.51-1.01s-.16-.82-.49-1.01c-.33-.19-.9-.29-1.73-.29h-1.61Z"></path>
    </svg>
  );
}
